var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _c("thead", [
              _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("th", [
                  _c(
                    "button",
                    {
                      staticClass: "btn-success",
                      attrs: { disabled: _vm.disabled },
                      on: { click: _vm.agregarTarifa }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ]),
                _vm._v(" "),
                _c("th", [_vm._v("Impuesto")]),
                _vm._v(" "),
                _c("th", [_vm._v("Base imponible")]),
                _vm._v(" "),
                _c("th", [_vm._v("Porcentaje")]),
                _vm._v(" "),
                _c("th", [_vm._v("Valor")]),
                _vm._v(" "),
                _c("th")
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.modelValue, function(tarifa, index) {
                  return _c("tr", { key: index }, [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(index + 1) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-info btn--text",
                          attrs: { disabled: _vm.disabled, type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.editarTarifa(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-edit" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        attrs: {
                          tooltip:
                            tarifa.selectedTarifa !== null &&
                            tarifa.selectedTarifa.nombre !== ""
                              ? tarifa.selectedTarifa.nombre
                              : "Seleccione..."
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "input-field",
                              {
                                attrs: {
                                  id: "tarifas" + index,
                                  placeholder: "Tarifa",
                                  readonly: "",
                                  value:
                                    tarifa.selectedTarifa != null
                                      ? tarifa.selectedTarifa.nombre
                                      : ""
                                }
                              },
                              [
                                _vm.errores.hasOwnProperty(
                                  "detalles." +
                                    index +
                                    ".selectedTarifa.id_tarifa"
                                )
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores[
                                                "items." +
                                                  index +
                                                  ".selectedTarifa.id_tarifa"
                                              ][0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm.errores.hasOwnProperty(
                                      "detalles." +
                                        index +
                                        ".selectedTarifa.id_impuesto"
                                    )
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores[
                                                "items." +
                                                  index +
                                                  ".selectedTarifa.id_impuesto"
                                              ][0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              vMoney: "",
                              format: _vm.money,
                              id: "baseImponible" + index,
                              placeholder: "$ #,###.##"
                            },
                            model: {
                              value: tarifa.base_imponible,
                              callback: function($$v) {
                                _vm.$set(tarifa, "base_imponible", $$v)
                              },
                              expression: "tarifa.base_imponible"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "detalles." + index + ".base_imponible"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores[
                                            "items." + index + ".base_imponible"
                                          ][0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              vMoney: "",
                              format: _vm.decimal,
                              id: "porcentaje" + index,
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: tarifa.porcentaje,
                              callback: function($$v) {
                                _vm.$set(tarifa, "porcentaje", $$v)
                              },
                              expression: "tarifa.porcentaje"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "detalles." + index + ".porcentaje"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores[
                                            "items." + index + ".porcentaje"
                                          ][0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              vMoney: "",
                              format: _vm.money,
                              id: "valor" + index
                            },
                            model: {
                              value: tarifa.valor,
                              callback: function($$v) {
                                _vm.$set(tarifa, "valor", $$v)
                              },
                              expression: "tarifa.valor"
                            }
                          },
                          [
                            _vm.errores.hasOwnProperty(
                              "detalles." + index + ".valor"
                            )
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores[
                                            "items." + index + ".valor"
                                          ][0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn-danger btn--text",
                          attrs: { disabled: _vm.disabled, type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.eliminarTarifa(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash-o" })]
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modelValue.length === 0,
                        expression: "modelValue.length === 0"
                      }
                    ]
                  },
                  [_vm._m(1)]
                )
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "itemRetencion",
            width: "60%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("item-retencion", {
            attrs: {
              venta: _vm.venta,
              codigoIva: _vm.codigoIva,
              codigoIsd: _vm.codigoIsd,
              codigoRenta: _vm.codigoRenta,
              baseImponibleIsd: _vm.baseImponibleIsd,
              baseImponibleIva: _vm.baseImponibleIva,
              baseImponibleRenta: _vm.baseImponibleRenta,
              impuestos: _vm.impuestos,
              fechaEmision: _vm.fechaEmision
            },
            on: { cancelar: _vm.cancelarTarifa, input: _vm.aceptarTarifa },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Detalle de la retención")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "6" } }, [
      _c("strong", [_vm._v("No se ha agregado detalles.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c358709", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c358709","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaDetalleRetencion.vue
// module id = 405
// module chunks = 0